module.exports = __webpack_public_path__ + "static/media/yy.768d8cd1.jpg";